import Expand from './../../expand';
import { querystring } from './../../../helpers';

const FilterCheckboxFacet = {
	name: 'FilterCheckboxFacet',
	props: {
		label: {
			type: String,
			required: true
		},
		expandable: {
			type: Boolean,
			required: false,
			default: false,
		},
		fieldName: {
			type: String,
			required: true,
		},
		param: {
			type: String,
			required: true,
		},
		value: {
			type: String,
			required: true,
		},
	},
	methods: {
		toggleCheckbox: function() {

			this.checked = !this.checked;
			if(this.expandable) {
				this.expand = this.checked;
			}

			this.$children.forEach(child => {
				if(child.$vnode.componentOptions.tag === 'filter-checkbox-facet') {
						if(this.checked) {
							child.checked = false;
						}
						child.toggleCheckbox();
				} else {
					child.checked = this.checked;
				}
			});

			this.$store.dispatch('filter/updated');

			if(this.hasParent()){
				this.updateParent();
			}
		},
		childItemUpdated: function() {
			const checkedChildItems = this.$children.filter(child => {
				return child.checked === true;
			});
			if(checkedChildItems.length == 0) {
				this.checked = false;
			} else if(checkedChildItems.length == this.$children.length) {
				this.checked = true;
			} else {
				this.checked = false;
			}

			this.updateParent();

		},
	},
	created: function() {
		this.updateParent = () => {
			if(this.$parent &&
				this.$parent.$vnode &&
				this.$parent.$vnode.componentOptions &&
				this.$parent.$vnode.componentOptions.tag === 'filter-checkbox-facet' &&
				typeof(this.$parent.childItemUpdated) === 'function') {
					this.$parent.childItemUpdated();
			}
		};
		this.hasParent = () => {
			if(this.$parent &&
				this.$parent.$vnode &&
				this.$parent.$vnode.componentOptions &&
				this.$parent.$vnode.componentOptions.tag == 'filter-checkbox-filter') {
					return true;
				}
				return false;
		};
	},
	data: function() {
		return {
			expand: false,
			checked: false,
			id: Math.random().toString(36).replace('0.', ''),
		};
	},
	watch: {
		checked: function(isChecked) {
			if(isChecked) {
				querystring.add(this.param, this.value);
			} else {
				querystring.remove(this.param, this.value);
			}
		},
	},
	mounted: function() {
		let checked = querystring.hasValue(this.param, this.value);
		if(this.$children.length > 0) {
			checked = this.$children.filter(child => {
				return child.checked === true;
			}).length > 0;
		}
		this.checked = checked;
		this.expand = checked;
	},
	template: `
		<div class="filter-group">
			<div class="filter-group__item">
				<input type="checkbox" :name="fieldName" :value="value" :checked="checked" :id="id" @change="toggleCheckbox" />
				<label :for="id">{{label}}</label><button @click="expand = !expand"><i class="icon-gunnebo-arrow-down" v-if="expandable" :class="{ 'icon-gunnebo-arrow-down--up': expand }" /></button>
			</div>
			<div class="filter-group__children" :class="{ 'filter-group__children--visible': expand}">
				<slot></slot>
			</div>
		</div>
	`,
	components: {
		Expand,
	}
};

export default FilterCheckboxFacet;



// WEBPACK FOOTER //
// ../shared/components/filter/filter-checkbox-facet/index.js